<template>
    <div class="shipping-method-overview" v-if="method">
        <template v-if="minimal">
            <div class="shipping-method-overview__container--minimal">
                <div class="shipping-method-overview__info--minimal">
                    <div class="shipping-method-overview__icon">
                        <img :src="method.img" alt="" tabindex="-1" />
                    </div>

                    <div class="shipping-method-overview__shipping-type" tabindex="0">
                        <span class="shipping-method-overview__shipping-description"> {{ method.description }} </span>
                        <span v-if="method.shippingTypeLoggi" v-text="$ml.get('within2Hours')" />
                        <span v-else-if="method.deadLine == 1" v-text="$ml.get('withinOneBusinessDay')" />
                        <span v-else-if="method.deadLine >= 2" v-text="$ml.with('0', method.deadLine).get('withinAnyBusinessDays')" />
                    </div>
                </div>

                <div class="shipping-method-overview__price" tabindex="0">
                    <span v-if="method.price != 0">{{ method.formattedPrice }}</span>
                    <span v-if="method.price == 0" class="free" v-text="$ml.get('free')" />
                </div>
            </div>
        </template>

        <template v-else>
            <div class="shipping-method-overview__container">
                <span class="shipping-method-overview__address" tabindex="0">
                    {{ ZipCode }} - {{ Street }}, {{ this.Number }} {{ District }}, {{ City }} - {{ State }}
                </span>

                <div class="shipping-method-overview__info">
                    <div tabindex="0">
                        <span class="shipping-method-overview__shipping-description"> {{ method.description }}</span>
                        <span v-if="method.shippingTypeLoggi" v-text="$ml.get('within2Hours')" />
                        <span v-else-if="method.deadLine == 1" v-text="$ml.get('withinOneBusinessDay')" />
                        <span v-else-if="method.deadLine >= 2" v-text="$ml.with('0', method.deadLine).get('withinAnyBusinessDays')" />
                    </div>

                    <div class="shipping-method-overview__price" tabindex="0">
                        <span v-if="method.price != 0">{{ method.formattedPrice }}</span>
                        <span v-if="method.price == 0" class="free" v-text="$ml.get('free')" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';

  export default {
      computed: {
          ...mapGetters({
              method: 'shippingType/getMethod'
          }),
          ...mapState('shippingAddress', ['ZipCode', 'Street', 'Number', 'Complement', 'District', 'City', 'State']),
      },
      props: {
          minimal: {
              type: Boolean,
              default: true
          }
      }
  };
</script>

<style lang="scss" scoped>

  .shipping-method-overview {
      display: flex;
      flex-direction: column;

      &__container--minimal {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 100%;
      }

      &__container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        max-width: 100%;
      }

      &__info--minimal {
          display: flex;
          align-items: center;

          span {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
          }
      }

      &__info {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          width: 100%;
          height: 100%;

          span {
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
              color: #000;
          }
      }

      &__icon {
          margin-right: 12px;

          @media screen and (min-width: 1025px) {
              margin-right: 20px;
          }
      }

      &__icon,
      img {
          width: 32px;
          height: 32px;
      }

      &__shipping-description {
          display: block;
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #000;
      }
      
      &__price {
          font-size: 16px;
          line-height: 24px;
          font-weight: 500;
          color: #000;

          .free {
              color: #00855D;
          }
      }

      &__address {
          display: block;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: #000;
          margin-bottom: 20px;
      }

      &__shipping-method {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
  }
</style>
